export function newMarkingId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }

  return `m_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
}
